var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeysInactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.636 4.87892C14.245 5.26995 14.245 5.90211 14.636 6.29314C15.0271 6.68417 15.6592 6.68417 16.0503 6.29314C16.4413 5.90211 16.4413 5.26995 16.0503 4.87892C15.6592 4.48789 15.0271 4.48789 14.636 4.87892Z",
    stroke: "#959EB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4645 3.46471C19.4175 5.41774 19.4175 8.58275 17.4645 10.5358C16.0156 11.9846 13.8999 12.3537 12.106 11.6516L9.68629 14.0713H8.27208V15.4855H6.85786V16.8997H4.02944V14.0713L9.27758 8.82317C8.57543 7.02924 8.94454 4.91357 10.3934 3.46471C12.3464 1.51168 15.5114 1.51168 17.4645 3.46471Z",
    stroke: "#959EB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeysInactiveIcon);
export default __webpack_public_path__ + "static/media/keysInactiveIcon.fde0385ee798fb52341f55e20810f410.svg";
export { ForwardRef as ReactComponent };